import { profile } from '../data/profile';

export const DAILY_LIMIT = 3;
export const MAX_QUESTION_LENGTH = 300;
const HISTORY_TURNS = 4;

const BASE_URL = `${process.env.REACT_APP_BACKEND_BASEURL}/chat`;
const VISITOR_KEY = 'ask-raven-visitor';

// A random id this browser keeps, so the backend can count one visitor's
// questions. The backend also counts per network, so clearing it buys little.
const visitorId = () => {
	try {
		let id = localStorage.getItem(VISITOR_KEY);
		if (!id) {
			id = crypto.randomUUID();
			localStorage.setItem(VISITOR_KEY, id);
		}
		return id;
	} catch {
		return '';
	}
};

const request = async (path, options = {}) => {
	const res = await fetch(`${BASE_URL}${path}`, {
		...options,
		headers: { 'content-type': 'application/json', 'x-visitor-id': visitorId(), ...options.headers },
	});
	const data = await res.json().catch(() => ({}));
	if (!res.ok) {
		const error = new Error(
			data.message || `Something went wrong on my end. You can email ${profile.shortName} at ${profile.email}.`,
		);
		error.remaining = data.remaining;
		throw error;
	}
	return data;
};

/** @returns {Promise<number>} questions this visitor has left today */
export const getRemaining = async () => (await request('/quota')).remaining;

/**
 * @param {string} question
 * @param {Array<{ from: 'user'|'bot', text: string }>} history earlier turns, oldest first
 * @returns {Promise<{ answer: string, remaining: number }>}
 */
export const askAssistant = (question, history) =>
	request('', { method: 'POST', body: JSON.stringify({ question, history: history.slice(-HISTORY_TURNS) }) });
